// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hes9","icon":"styles_icon__2m8Lx"};